import { apiClient } from "./client";

export type NotificationKind =
  | "PLANNING_PUBLISHED"
  | "OPEN_SHIFT_PUBLISHED"
  | "OPEN_SHIFT_APPLICATION_ACCEPTED"
  | "OPEN_SHIFT_APPLICATION_REJECTED"
  | "DESIDERATA_WINDOW_OPENED"
  | "DESIDERATA_WINDOW_CLOSING_SOON"
  | "COVERAGE_REQUEST"
  | "COVERAGE_COVERED"
  | "SWAP_PROPOSED"
  | "SWAP_ACCEPTED"
  | "SWAP_REJECTED"
  | "PLAN_BLANC_DECLARED"
  | "PLAN_BLANC_ENDED"
  | "DOC_EXPIRING_SOON"
  | "GENERIC";

export type Notification = {
  id: string;
  kind: NotificationKind;
  title: string;
  body: string | null;
  link: string | null;
  payload: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string;
};

export type UnreadCount = { unread: number };

export async function listNotifications(unreadOnly = false, limit = 50): Promise<Notification[]> {
  const { data } = await apiClient.get<Notification[]>("/api/v1/me/notifications", {
    params: { unread_only: unreadOnly, limit },
  });
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<UnreadCount>("/api/v1/me/notifications/unread-count");
  return data.unread;
}

export async function markNotificationRead(id: string): Promise<Notification> {
  const { data } = await apiClient.post<Notification>(`/api/v1/me/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post("/api/v1/me/notifications/mark-all-read");
}

export async function deleteNotification(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/me/notifications/${id}`);
}
